import React, { useEffect, useState } from "react";
import './ThemeToggle.css';

const ThemeToggle = () => {
    const getInitialTheme = () => {
        const savedTheme = localStorage.getItem("theme");
        return savedTheme ? JSON.parse(savedTheme) : true;
    };

    const [light, setLight] = useState(getInitialTheme);

    useEffect(() => {
        document.body.className = light ? "light-mode" : "dark-mode";
        localStorage.setItem("theme", JSON.stringify(light));
    }, [light]);

    return (
        <div className="theme-toggle-container">
            <button className="theme-toggle" onClick={() => setLight(l => !l)}>
                {light ? "Tumma teema" : "Vaalea teema"}
            </button>
        </div>
    );
};

export default ThemeToggle;